import React, { useState, useRef, useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { Icon } from '../Icon/Icon';
import { withFormElementStyle } from '../Form/withFormElementStyle';
import { withValidation } from '../Form/withValidation';

const useCheckboxStyles = createUseStyles({
  root: {
    display: 'inline-block',
    cursor: 'pointer',
    userSelect: 'none',
    font: '400 16px arial',
    color: 'var(--first-text-color)',
    padding: 5,
  },
  knob: {
    textAlign: 'center',
    width: 20,
    height: 20,
    borderRadius: '20%',
  },
  on: {
    backgroundColor: 'var(--second-color)',
  },
  off: {
    backgroundColor: 'var(--first-color)',
  },
  icon: {
    fontSize: 'unset',
    color: 'var(--background-color)',
  },
  hiddenInput: {
    display: 'none',
  },
});

const Checkbox = React.forwardRef(({ checked, onChange, validation, ...props }, forwardedRef) => {
  const classes = useCheckboxStyles();
  const defaultRef = useRef(null);
  const internalRef = forwardedRef || defaultRef;
  const isControlled = checked !== undefined;
  const [internalChecked, setInternalChecked] = useState(!!checked);

  useEffect(() => {
    if (isControlled) {
      setInternalChecked(checked);
    }
  }, [checked, isControlled]);

  const handleInputChange = (e) => {
    if (!isControlled) {
      setInternalChecked(e.target.checked);
    }
    if (onChange) {
      onChange(e);
    }
  };

  const handleClick = () => {
    if (internalRef.current) {
      internalRef.current.click();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      className={classes.root}
      onClick={handleClick}
      role='checkbox'
      aria-checked={internalChecked}
      tabIndex={0}
      onKeyDown={handleKeyDown}
    >
      <div className={[classes.knob, internalChecked ? classes.on : classes.off].join(' ')}>
        <Icon className={classes.icon}>{internalChecked ? 'check' : 'close'}</Icon>
        <input
          {...props}
          ref={internalRef}
          type='checkbox'
          checked={internalChecked}
          onChange={handleInputChange}
          className={classes.hiddenInput}
        />
      </div>
    </div>
  );
});

export default withValidation(withFormElementStyle(Checkbox));
